/* eslint-disable max-statements */
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { useGetDirectReporteesQuery } from '../../features/coaching/coachingHistoryGrid/coachingHistoryGridSlice';
import {
    selectCurrentEmpid,
    selectCurrentRole,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectIsUseCoachingSkills,
} from '../../pages/login/authSlice';
import { datetimeToDate } from '../../utils/dateFormat';
import { CoachingEntityTypes, CoachingTabs } from '../../utils/typeConstants';
import { SkillBehaviorDropdown } from '../skillBehaviorDropdown/SkillBehaviorDropdown';
import {
    useGetCoachingActionQuery,
    useGetCoachingBehaviorByIdQuery,
} from '../skillBehaviorDropdown/skillBehaviorDropdownSlice';
import { CoachingAction, CoachingBehavior } from '../skillBehaviorDropdown/types';
import { CascadeToDo } from './CascadeToDo';
import {
    useCoachingUserSearchQuery,
    useCreateCoachingToDoMutation,
    useGetCoachingToDoDetailsQuery,
} from './CoachingToDoSlice';
import {
    GetTeamOptions,
    allowExpansion,
    dueBodyTemplate,
    getRole,
    statusBodyTemplate,
} from './coachingToDo-service';
import './coachingToDo.scss';
import DescriptionBox from '../descriptionBox/DescriptionBox';

export type ToDoData = {
    employeenumber: number;
    empName: string;
    startDate: Date | null;
    dueDate: Date | null;
    to_do_description: string;
    status: string;
    to_do_title: string;
};
interface CoachingToDoProps {
    receiverId?: string;
    receiverName?: string;
    coachingEntityTypeId?: number;
    coachingEntityId?: number;
    coachingStatusId?: number; //only for kanban
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    todoDescription?: string;
    via?: number;
    todoTitle?: string;
    skill?: number;
    behavior?: number;
    backgroundColor?: string;
}
const CoachingToDo: React.FC<CoachingToDoProps> = (props) => {
    const loggedEmpUserName = useSelector(selectCurrentUser);
    const toastPrime = useRef<Toast>(null);
    const [isVisible, setIsVisible] = useState(false);
    const currentEmpId = useSelector(selectCurrentEmpid);
    const empId = props.receiverId ? props.receiverId : currentEmpId;
    const empName = props.receiverName;
    const [appliesTo, setAppliesTo] = useState<string>('');
    const [title, setTitle] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [startDate, setStartDate] = useState<Date>(new Date());
    const [dueDate, setDueDate] = useState<Date | null>(null);
    const [expandedRows, setExpandedRows] = useState<any>();
    const [searchEmployeeNumber, setSearchEmployeeNumber] = useState<number>();
    const [selectedTeamOption, setSelectedTeamOption] = useState<string>('');
    const [teamOptions, setTeamOptions] = useState<any>([]);
    const [selectedEmpList, setSelectedEmpList] = useState<any>();
    const [selectedEmp, setSelectedEmp] = useState<string>('');
    const loggedUser = useSelector(selectCurrentEmpid);
    const userMngrRole = useSelector(selectCurrentUserManagerLevel);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [coachingActions, setCoachingActions] = useState<CoachingAction[]>([]);
    const [isCascadeSaveSuccess, setIsCascadeSaveSuccess] = useState(false);
    const [todoDetails, setTodoDetails] = useState<any>();
    const [visibleConfirmDialog, setVisibleConfirmDialog] = useState(false);
    const employeeId =
        props?.coachingEntityTypeId === 1 && searchEmployeeNumber ? searchEmployeeNumber.toString() : empId;
    const [createToDo] = useCreateCoachingToDoMutation();
    const [toDoData, setToDoData] = useState<any>([]);
    const { data: toDoDataList } = useGetCoachingToDoDetailsQuery(
        { employeenumber: employeeId },
        { skip: !employeeId }
    );
    const userRole = getRole(useSelector(selectCurrentRole));
    const [skill, setSkill] = useState(0);
    const [behavior, setBehavior] = useState(0);
    const [simulationUrl, setSimulationUrl] = useState('');
    const [trainingUrl, setTrainingUrl] = useState('');
    const [behaviorName, setBehaviorName] = useState('');
    const [selectedAction, setSelectedAction] = useState<CoachingAction | null>(null);
    const [selectedActionID, setSelectedActionID] = useState<number | null>(null);

    const isUseCoachingSkills = useSelector(selectIsUseCoachingSkills);

    const DialogueHeader = 'To Do';
    const searchTitle = DialogueHeader === 'To Do' ? 'todo' : '';
    const [optionsBehaviors, setOptionsBehaviors] = useState([]);

    const { data: coachingActionData } = useGetCoachingActionQuery(
        {
            employeeNumber: currentEmpId,
            coachingBehaviorId: behavior,
        },
        { skip: !currentEmpId }
    );
    const { data: behaviorData } = useGetCoachingBehaviorByIdQuery(
        {
            employeeNumber: currentEmpId,
            coachingSkillId: props.skill,
        },
        {
            skip: !props.skill || !currentEmpId,
        }
    );

    useEffect(() => {
        setCoachingActions([]);
        setSelectedAction(null);
        setTrainingUrl('');

        if (coachingActionData?.data.length > 0) {
            setCoachingActions(coachingActionData.data);
        } else {
            setCoachingActions([]);
        }
    }, [coachingActionData, behaviorName, skill]);

    const { data: userData } = useCoachingUserSearchQuery({
        employeeNumber: currentEmpId,
        searchEmployeeNumber,
        title: searchTitle,
        userRole,
    });
    const { data: directReportees } = useGetDirectReporteesQuery(
        {
            employeeNo: parseInt(loggedUser, 10),
        },
        {
            skip: !loggedUser,
        }
    );
    useEffect(() => {
        if (props?.todoTitle) {
            setTitle(props?.todoTitle);
        }
    }, [props?.todoTitle]);

    useEffect(() => {
        if (props?.skill) {
            setSkill(props?.skill);
        }
        if (props?.behavior) {
            setBehavior(props?.behavior);
        }
    }, [props?.skill, props?.behavior]);
    useEffect(() => {
        if (directReportees?.data?.length > 0) {
            const employeeNames = directReportees.data.map((employee: any) => ({
                label: employee.employee_name,
                value: employee.employee_number,
            }));
            setSelectedEmpList(employeeNames);
        }
    }, [directReportees]);
    useEffect(() => {
        setTeamOptions(GetTeamOptions(userMngrRole));
    }, [selectedTeamOption]);
    useEffect(() => {
        if (!props.visible) {
            setAppliesTo('');
            setIsVisible(false);
        }
    }, [props.visible]);
    useEffect(() => {
        if (props.coachingEntityTypeId === CoachingEntityTypes.CoachingInsights) {
            setDescription(props.todoDescription || '');
        }
    }, [props.todoDescription]);
    useEffect(() => {
        if (isCascadeSaveSuccess === true) props.setVisible(false);
    }, [isCascadeSaveSuccess]);
    const accept = () => {
        setVisibleConfirmDialog(false);
        const todo = {
            employeeNumber: employeeId,
            employeeName: props?.coachingEntityTypeId === 1 ? appliesTo : empName,
            createBy: currentEmpId,
            coachingEntityTypeId: props.coachingEntityTypeId,
            coachingEntityId: props.coachingEntityId,
            title,
            description,
            startDate: startDate !== null ? datetimeToDate(startDate) : startDate,
            dueDate: dueDate !== null ? datetimeToDate(dueDate) : dueDate,
            coachingStatusId: props.coachingStatusId,
        };
        setTodoDetails(todo);
        setDialogVisible(true);
    };

    const reject = () => {
        setVisibleConfirmDialog(false);
    };
    useEffect(() => {
        if (visibleConfirmDialog) {
            confirmDialog({
                message: 'You are about to cascade this To Do to other users. Do you want to continue?',
                header: 'Cascade To Do',
                icon: 'pi pi-info-circle',
                acceptLabel: 'Continue',
                rejectLabel: 'Cancel',
                style: { width: '460px' },
                accept,
                reject,
                visible: visibleConfirmDialog,
            });
        }
    }, [visibleConfirmDialog]);

    const handleSave = () => {
        if (description?.length > 4000) {
            return;
        }
        createToDo({
            employeeNumbers: [employeeId],
            createBy: currentEmpId,
            coachingEntityTypeId: props.coachingEntityTypeId,
            coachingEntityId: props.coachingEntityId,
            title,
            description,
            startDate: startDate !== null ? datetimeToDate(startDate) : startDate,
            dueDate: dueDate !== null ? datetimeToDate(dueDate) : dueDate,
            coachingStatusId: props.coachingStatusId,
            coachingSkillId: skill === 0 ? null : skill,
            coachingBehaviorId: behavior === 0 ? null : behavior,
            coachingActionId: selectedAction?.coaching_action_id ?? null,
            trainingName: behaviorName === '' || behaviorName === null ? null : behaviorName + ' Simulation',
            trainingUrls: trainingUrl === null || trainingUrl === '' ? [] : [trainingUrl],
        })
            .unwrap()
            .then((res: any) => {
                if (res.data) {
                    if (props?.todoTitle === undefined) {
                        setTitle('');
                    }
                    setDescription('');
                    setStartDate(new Date());
                    setDueDate(null);
                    if (res.data === 'Successfully inserted') {
                        toast.success('ToDo created successfully.');
                        setSelectedAction(null);
                        setTrainingUrl('');
                    } else {
                        toast.error(
                            'There is another active To Do with the same title. Please provide a distinct title for the ToDo.'
                        );
                    }
                    props.setVisible(false);
                }
            })
            .catch(() => {
                toast.error('ToDo creation failed.');
            });
    };

    useEffect(() => {
        setToDoData({ data: toDoDataList?.data });
        if (props.via === CoachingTabs.CoachingInsights) {
            setToDoData({
                data:
                    toDoDataList?.data.filter(
                        (item: any) =>
                            item.coaching_entity_id === props.coachingEntityId &&
                            item.coaching_entity_type_id === CoachingEntityTypes.CoachingInsights
                    ) || [],
            });
        }
    }, [toDoDataList]);
    useEffect(() => {
        if (selectedTeamOption === 'mytodo') {
            setIsVisible(true);
            setSearchEmployeeNumber(parseInt(loggedUser, 10));
        } else {
            setIsVisible(false);
            setSearchEmployeeNumber(undefined);
        }
        if (
            props.visible &&
            props?.coachingEntityTypeId === 1 &&
            userRole === 'agent' &&
            selectedTeamOption === ''
        ) {
            setSelectedTeamOption('mytodo');
        }
    }, [selectedTeamOption, props.visible, props?.coachingEntityTypeId, userRole]);
    const rowExpansionTemplate = (data: ToDoData) => {
        return (
            <InputTextarea
                readOnly
                className="borderRadius8 w-100 todoview-readonlydesc"
                value={data.to_do_description}
                maxLength={4000}
                autoResize={false}
            />
        );
    };
    useEffect(() => {
        // Check if userData has data and execute the logic
        if (userData?.data) {
            if (searchEmployeeNumber?.toString().length === 7) {
                if (userData.data.includes(searchEmployeeNumber)) {
                    setAppliesTo(userData.data);
                    setIsVisible(true);
                } else {
                    toastPrime.current?.show({
                        severity: 'warn',
                        summary: 'Warning Message',
                        detail: userData.data,
                        life: 3000,
                    });
                }
            }
        }
    }, [userData]);
    const handleSearchEmployeeNumberChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = Number(e.target.value);
            if (value.toString().length === 7) {
                setSearchEmployeeNumber(value);
            }
            if (value.toString().length !== 7) {
                setAppliesTo('');
                setIsVisible(false);
            }
        },

        [searchEmployeeNumber]
    );
    const footerContent = (
        //For Latest ToDos
        <Accordion style={{ marginTop: '1rem' }}>
            <AccordionTab header="Latest To Dos">
                <DataTable
                    value={toDoData?.data}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                    rowExpansionTemplate={rowExpansionTemplate}
                >
                    <Column header="Title" field={'to_do_title'} />
                    <Column header="Due" field={'due_date'} body={dueBodyTemplate} />
                    <Column header="Status" field={'coaching_to_do_status_id'} body={statusBodyTemplate} />
                    <Column expander={allowExpansion} />
                </DataTable>
            </AccordionTab>
        </Accordion>
    );
    const currentDate = new Date();

    const convertHtmlToPlainText = (html: string): string => {
        if (!html) return '';

        // Create a temporary div element to parse HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Extract all <li> elements and convert them to bullet points
        const listItems = tempDiv.querySelectorAll('li');
        const formattedList: string[] = [];

        listItems.forEach((li) => {
            const textContent = li.textContent?.trim() ?? ''; // Extract text safely
            formattedList.push(`• ${textContent}`); // ✅ Add bullet dot instead of '-'
        });

        // Join formatted list with new lines
        return formattedList.join('\n').trim(); // Ensure proper spacing between items
    };

    useEffect(() => {
        if (behaviorData?.data.length > 0) {
            setOptionsBehaviors(behaviorData.data);
        }
    }, [behaviorData]);

    const handleSelect = (selectedAction: CoachingAction | null) => {
        const coachingActionDescription = convertHtmlToPlainText(
            selectedAction?.coaching_action_description ?? ''
        );

        const toDoDescription = `${(
            selectedAction?.coaching_action_name ?? ''
        ).trim()} : \n${coachingActionDescription.trim()}`;
        setSelectedActionID(selectedAction?.coaching_action_id ?? null);
        if (selectedAction?.coaching_action_id === 5) {
            if (simulationUrl === '') {
                const selectedBehavior: CoachingBehavior | undefined = optionsBehaviors.find(
                    (behavior: CoachingBehavior) => behavior.coaching_behavior_id === props?.behavior
                );
                if (selectedBehavior) {
                    setTrainingUrl((selectedBehavior as CoachingBehavior)?.simulation_url);
                }
            } else setTrainingUrl(simulationUrl);
        } else {
            setTrainingUrl('');
        }

        setDescription(toDoDescription.replace(/\n/g, '\r\n'));

        // console.log(skill,behavior,selectedAction?.coaching_action_id,'-----',simulationUrl,behaviorName)
    };

    const handleSelectChange = (e: { value: CoachingAction }) => {
        setSelectedAction(e.value);
        handleSelect(e.value);
    };

    const handleDescriptionChange = (value: string) => {
        setDescription(value);
    };

    const coachingActionsTemplate = (option: CoachingAction) => (
        <div>
            <div>{option.coaching_action_name}</div>
            <div
                style={{
                    whiteSpace: 'pre-line',
                    width: '250px',
                    fontSize: '12px',
                    wordWrap: 'break-word',
                    fontWeight: '400',
                }}
                dangerouslySetInnerHTML={{ __html: option.coaching_action_description }}
            />
        </div>
    );

    return (
        <div className="flex justify-content-center">
            <ConfirmDialog visible={visibleConfirmDialog} />
            <Button
                label="To Do"
                icon="pi pi-comment"
                onClick={() => {
                    props.setVisible(true);
                    setDescription('');
                    setStartDate(new Date());
                    setDueDate(null);
                }}
                style={{ backgroundColor: props?.backgroundColor ? props.backgroundColor : '#3299ff', color: 'white', whiteSpace: 'nowrap' }}
                hidden={props?.visible}
                className='btn-primary me-2'
            />
            <Dialog
                header={DialogueHeader}
                visible={props.visible}
                style={{ width: '50vw' }}
                onHide={() => {
                    props.setVisible(false);
                    setSelectedAction(null);
                    setTrainingUrl('');
                }}
                footer={footerContent}
            >
                <div className="row">
                    {props?.coachingEntityTypeId === 1 && userRole !== 'agent' && (
                        <>
                            <div className="col-md-4">
                                <h6 style={{ fontWeight: '600', fontSize: '16px' }}>Select Team</h6>
                                <Dropdown
                                    value={selectedTeamOption}
                                    onChange={(event) => {
                                        setSelectedTeamOption(event.target.value);
                                    }}
                                    options={teamOptions}
                                    optionLabel={'name'}
                                    optionValue={'code'}
                                    placeholder="Select Team"
                                    className="custom-dropdown w-200 me-2"
                                />
                            </div>
                            {selectedTeamOption === 'myteam' && (
                                <div className="col-md-4">
                                    <div className="content">
                                        <h6 style={{ fontWeight: '600', fontSize: '16px' }}>
                                            Select Employee
                                        </h6>
                                        <Dropdown
                                            id="selectedEmp"
                                            name="Select Employee"
                                            placeholder="Select Employee"
                                            className="custom-dropdown w-200"
                                            options={selectedEmpList}
                                            optionValue={'value'}
                                            optionLabel={'label'}
                                            value={selectedEmp}
                                            onChange={(event) => {
                                                setSelectedEmp(event.target.value);
                                                setSearchEmployeeNumber(event.target.value);
                                                setIsVisible(true);
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                            {selectedTeamOption === 'search' && (
                                <div className="col-md-5">
                                    <h6 style={{ fontWeight: '600', fontSize: '16px' }}>
                                        Search Employee by Oracle ID
                                    </h6>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span className="p-input-icon-left">
                                            <i className="pi pi-search" />
                                            <InputText
                                                placeholder="Search"
                                                onChange={handleSearchEmployeeNumberChange}
                                                maxLength={10}
                                                keyfilter="pnum"
                                            />
                                        </span>
                                    </div>

                                    <Toast ref={toastPrime} />
                                </div>
                            )}
                        </>
                    )}
                    <div
                        className={
                            props?.coachingEntityTypeId === 1 ? `toDoData ${isVisible ? '' : 'hidden'}` : ''
                        }
                    >
                        <p style={{ marginTop: '.5rem' }}>Assigned To</p>

                        <p style={{ color: 'grey', marginTop: '-0.3rem' }}>
                            {props?.coachingEntityTypeId === 1 ? appliesTo : empName}
                        </p>

                        <p>Title</p>
                        <div>
                            <InputText
                                id="Title"
                                value={title}
                                onChange={(e) => {
                                    setTitle(e.target.value);
                                }}
                                placeholder="Title"
                                className='w-100'
                            />
                        </div>

                        {isUseCoachingSkills && (props?.coachingEntityTypeId === CoachingEntityTypes.Metrics) && (
                            <div style={{ marginTop: '1rem', display: 'flex' }}>
                                <div style={{ width: '600px' }}>
                                    <SkillBehaviorDropdown
                                        fullWidth
                                        skill={skill}
                                        setSkill={setSkill}
                                        behavior={behavior}
                                        setBehavior={setBehavior}
                                        simulationUrl={simulationUrl}
                                        setSimulationUrl={setSimulationUrl}
                                        setBehaviorName={setBehaviorName}
                                    />
                                </div>

                                <div>
                                    <h6>Action Item</h6>
                                    <Dropdown
                                        value={selectedAction}
                                        options={coachingActions}
                                        onChange={handleSelectChange}
                                        optionLabel="coaching_action_name"
                                        placeholder="Select a Coaching Action"
                                        itemTemplate={coachingActionsTemplate}
                                        panelClassName="custom-dropdown-panel"
                                        className="borderRadius8 w-100"
                                    />
                                </div>
                            </div>
                        )}

                        <div style={{ margin: '1rem 0' }}>
                            <DescriptionBox
                                createdByLabel="Author"
                                createdByValue={loggedEmpUserName}
                                title={'Description'}
                                responseDescription={description}
                                value={description}
                                limit={4000}
                                onChange={handleDescriptionChange}
                            />
                            {selectedActionID !== null && selectedActionID === 5 && (
                                <a
                                    style={{ padding: '8px' }}
                                    href={trainingUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {trainingUrl}
                                </a>
                            )}
                        </div>
                        <div style={{ display: 'flex', marginTop: '1rem' }}>
                            <div style={{ marginRight: '1rem' }}>
                                <p>Start Date</p>
                                <div
                                    // className="card flex justify-content-center"
                                    style={{ borderRadius: '.8rem' }}
                                >
                                    <Calendar
                                        value={startDate}
                                        dateFormat="dd-M-yy"
                                        onChange={(e: any) => {
                                            setStartDate(e.value);
                                        }}
                                        showIcon
                                        minDate={
                                            new Date(
                                                currentDate.getFullYear() - 1,
                                                currentDate.getMonth(),
                                                currentDate.getDate()
                                            )
                                        }
                                        className="custom-calendar"
                                    />
                                </div>
                            </div>
                            <div>
                                <p>Due Date</p>
                                <div
                                    // className="card flex justify-content-center"
                                    style={{ borderRadius: '.8rem' }}
                                >
                                    <Calendar
                                        value={dueDate}
                                        dateFormat="dd-M-yy"
                                        onChange={(e: any) => {
                                            setDueDate(e.value);
                                        }}
                                        showIcon
                                        minDate={startDate || undefined}
                                        disabled={!startDate}
                                        className="custom-calendar"
                                    />
                                </div>
                            </div>
                        </div>
                        <div>
                            {userRole !== 'agent' && (
                                <div style={{ float: 'left', marginTop: '1rem', display: 'block' }}>
                                    <Button
                                        label="Cascade"
                                        onClick={() => {
                                            setVisibleConfirmDialog(true);
                                        }}
                                        autoFocus
                                        disabled={!title || !description || !startDate || !dueDate}
                                        className="btn-primary"
                                    />
                                </div>
                            )}
                            <div style={{ float: 'right', marginTop: '1rem', display: 'block' }}>
                                <Button
                                    label="Cancel"
                                    onClick={() => {
                                        props.setVisible(false);
                                        setSelectedAction(null);
                                        setTrainingUrl('');
                                    }}
                                    className="btn-secondary me-2"
                                // style={{ border: '1px solid #3299ff', marginRight: '1rem' }}
                                />
                                <Button
                                    label="Save"
                                    onClick={() => {
                                        handleSave();
                                    }}
                                    autoFocus
                                    disabled={!title || !description || !startDate || !dueDate}
                                    className="btn-primary"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {dialogVisible && (
                <CascadeToDo
                    visible={dialogVisible}
                    setVisible={setDialogVisible}
                    setIsSaveSuccess={setIsCascadeSaveSuccess}
                    todoDeatails={todoDetails}
                />
            )}
        </div>
    );
};
export default CoachingToDo;
